import { render, staticRenderFns } from "./ResearchIndex.vue?vue&type=template&id=1a2df06d&scoped=true"
import script from "./ResearchIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ResearchIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResearchIndex.vue?vue&type=style&index=0&id=1a2df06d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2df06d",
  null
  
)

export default component.exports